import { withInstall } from '@touchvue/utils';
import Dialog from './src/Dialog.vue';

export const ToDialog = withInstall(Dialog);
export default ToDialog;

export * from './src/dialog';
